import ROUTE_PATH from './routes.config';

export const ACCESS_RIGHTS_MASTER_ADMIN = {
  defaultRoute: ROUTE_PATH.DASHBOARD,
  dashboard: {
    view: true,
  },
  subscribers: {
    create: true,
    edit: true,
    view: true,
    manage_notes: true,
    change_password: true,
    login_as_subscriber: true,
    import_subscriber_emails: true,
    delete: true,
  },
  community_groups: {
    create: true,
    edit: true,
    view: true,
    upload_poster: true,
    translate: true,
    delete: true,
  },
  quiz: {
    create: true,
    edit: true,
    view: true,
    manage_questions: true,
    view_results: true,
    view_subscriber_results: true,
    translate: false,
    delete: true,
  },
  manage_members: {
    view: true,
    create: true,
    edit: true,
    delete: true,
  },
  users: {
    create: true,
    edit: true,
    view: true,
    change_password: true,
    delete: true,
  },
  program_courses: {
    create: true,
    edit: true,
    view: true,
    translate: true,
    delete: true,
  },
  videos: {
    create: true,
    sync: true,
    edit: true,
    translate: true,
    view: true,
    upload_assets: true,
    manage_recurring_events: true,
    view_registrations: true,
    delete: true,
  },
  resources: {
    create: true,
    edit: true,
    view: true,
    upload_assets: true,
    translate: true,
    delete: true,
  },
  community_gatherings_zoom: {
    create: true,
    edit: true,
    view: true,
    upload_poster: true,
    translate: true,
    delete: true,
  },
  leading_teachers: {
    create: true,
    edit: true,
    view: true,
    upload_poster: true,
    translate: true,
    delete: true,
  },
  ms_voice_recorded_videos: {
    view: true,
  },
  ms_voice_recorded_audios: {
    view: true,
  },
  sequence: {
    edit: true,
    edit_video: true,
    view: true,
  },
  testimonials_user_text_testimonials: {
    view: true,
    delete: true,
  },
  testimonials_user_video_testimonials: {
    sync: true,
    view: true,
    upload_video: true,
    delete: true,
    download: true,
  },
  notifications: {
    view: true,
    edit: true,
    translate: true,
  },
  video_watch_overview: {
    view: true,
    download: true,
  },
  video_watch_sessions: {
    view: true,
  },
  live_users: {
    view: true,
  },
  live_event_report: {
    view: true,
  },
  data_change_logs: {
    view: true,
  },
};

export const ACCESS_RIGHTS_ADMIN = {
  defaultRoute: ROUTE_PATH.DASHBOARD,
  dashboard: {
    view: true,
  },
  subscribers: {
    create: true,
    edit: true,
    view: true,
    manage_notes: true,
    change_password: true,
    login_as_subscriber: true,
    import_subscriber_emails: true,
    delete: true,
  },
  community_groups: {
    create: true,
    edit: true,
    view: true,
    upload_poster: true,
    translate: true,
    delete: true,
  },
  quiz: {
    create: true,
    edit: true,
    view: true,
    manage_questions: true,
    view_results: true,
    view_subscriber_results: true,
    translate: false,
    delete: true,
  },
  manage_members: {
    view: true,
    create: true,
    edit: true,
    delete: true,
  },
  program_courses: {
    create: true,
    edit: true,
    view: true,
    translate: true,
    delete: true,
  },
  videos: {
    create: true,
    sync: true,
    edit: true,
    translate: true,
    view: true,
    upload_assets: true,
    manage_recurring_events: true,
    view_registrations: true,
    delete: true,
  },
  resources: {
    create: true,
    edit: true,
    view: true,
    upload_assets: true,
    translate: true,
    delete: true,
  },
  community_gatherings_zoom: {
    create: true,
    edit: true,
    view: true,
    upload_poster: true,
    translate: true,
    delete: true,
  },
  leading_teachers: {
    create: true,
    edit: true,
    view: true,
    upload_poster: true,
    translate: true,
    delete: true,
  },
  ms_voice_recorded_videos: {
    view: true,
  },
  ms_voice_recorded_audios: {
    view: true,
  },
  sequence: {
    edit: true,
    edit_video: true,
    view: true,
  },
  testimonials_user_text_testimonials: {
    view: true,
    delete: true,
  },
  testimonials_user_video_testimonials: {
    sync: true,
    view: true,
    upload_video: true,
    delete: true,
    download: true,
  },
  notifications: {
    view: true,
    edit: true,
    translate: true,
  },
  video_watch_overview: {
    view: true,
    download: true,
  },
  video_watch_sessions: {
    view: true,
  },
  live_users: {
    view: true,
  },
  live_event_report: {
    view: true,
  },
  data_change_logs: {
    view: true,
  },
};
